import { Header, NonCancelableCustomEvent, Tabs, TabsProps } from '@amzn/awsui-components-react';
import { useContext, useEffect, useState } from 'react';
import { RouteComponentProps,useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

import { HelpPanelTopicOptions } from '../../common/Constants';
import { constants } from '../../common/Localization';
import { MatchParam } from '../../common/types';
import { HelpPanelContext } from '../../contexts/HelpPanelContext';
import Application from '../portfolio-data-asset/Application';
import DatabasePage from '../portfolio-data-asset/Database';
import { InlineEditProvider } from '../portfolio-data-asset/inline-editing/InlineEditContext';
import Server from '../portfolio-data-asset/Server';
import MainframePage from './MainframePage';
import NetworkPage from './NetworkPage';
import SharedStoragePage from './SharedStoragePage';

type AssetPagesProps = RouteComponentProps<MatchParam>;

function AssetPages(props: AssetPagesProps) {
    const { params } = props.match;
    const { portfolioId } = params;
    const location = useLocation();
    const history = useHistory();
    const [ activeTabId, setActiveTabId ] = useState('servers');
    const { panelHandler } = useContext(HelpPanelContext);
    
    useEffect(() => {
        panelHandler(HelpPanelTopicOptions.ASSETS);
    }, [ activeTabId, panelHandler ]);

    useEffect(() => {
        const locationParts: string[] = location.pathname.split('/');
        const activeTab = locationParts[locationParts.length - 1] === 'assets' ? 'servers' : locationParts[locationParts.length - 1];
        setActiveTabId(activeTab);
    }, [location]);

    const tabDefinition: TabsProps.Tab[] = [
        { 
            label: 'Servers', 
            id: 'servers',
            href: `/portfolio/${portfolioId}/management/assets/servers`,
            content: <Server />
        },
        { 
            label: 'Applications', 
            id: 'applications', 
            href: `/portfolio/${portfolioId}/management/assets/applications`,
            content: <Application /> 
        },
        { 
            label: 'Databases', 
            id: 'databases', 
            href: `/portfolio/${portfolioId}/management/assets/databases`,
            content: <DatabasePage /> 
        },
        { 
            label: 'Shared storage', 
            id: 'additional-storage', 
            href: `/portfolio/${portfolioId}/management/assets/additional-storage`,
            content: <SharedStoragePage/> 
        },
        { 
            label: 'Network', 
            id: 'network', 
            href: `/portfolio/${portfolioId}/management/assets/network`,
            content: <NetworkPage/> 
        },
        { 
            id: 'mainframe', 
            label: 'Mainframe', 
            href: `/portfolio/${portfolioId}/management/assets/mainframe`,
            content: <MainframePage/> 
        },
    ];

    const onTabChange = (event: NonCancelableCustomEvent<TabsProps.ChangeDetail>): void => {
        if (event.detail.activeTabHref) {
            history.push(event.detail.activeTabHref);
        }
        setActiveTabId(event.detail.activeTabId);
    };

    return (
        <div data-testid='assetPages'>
            <Header variant='h1'>{constants.MANAGE_ASSETS}</Header>
            <InlineEditProvider>
                <Tabs activeTabId={activeTabId} tabs={tabDefinition} onChange={onTabChange}/>
            </InlineEditProvider>
        </div>
    );
}

export default AssetPages;
